export const JOBS_ROUTE = "/jobs";
export const JOBS_APPROVAL_ROUTE = "/approvals/jobs";

export const PR_CATEGORIES_LIST: string[] = [
  "Structure strengthening",
  "Civil Work",
  "Civil Finishes",
  "Loose Furniture",
  "Façade",
  "Horticulture",
  "Art Work",
  "Graphic, Signages, floor directories, Motem etc",
  "Electrical Work",
  "FA & PA",
  "BMS",
  "DG",
  "CCTV",
  "HVAC",
  "Chiller",
  "Plumbing & Fire Fighting",
  "Lift",
  "Telecommunication(EPABX included)",
  "Medical Gases",
  "Dumb Waiter",
  "OT",
  "Nurse Call",
  "CSSD",
  "Kitchen Equipments",
  "Lab Equipments",
  "Blood Bank",
  "LPG/PNG line for kitchen",
  "LMO",
  "Pneumatic Chute",
  "Laundary",
  "PRI Line from Airtel/Jio/Vodafone",
  "Electrical connection",
  "Water connection",
  "Sewer connection",
  "Rain water connection",
  "TV",
  "Solar panel",
  "Fire Doors",
  "Statutory charges are exclusive",
  "Pendant for OT",
];
